import { render, staticRenderFns } from "./salesRecord.vue?vue&type=template&id=0475c842&"
import script from "./salesRecord.vue?vue&type=script&lang=js&"
export * from "./salesRecord.vue?vue&type=script&lang=js&"
import style0 from "./salesRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports